import { formatDate_YMDHMS, roundDateToFloor } from "@/_core/_helpers/_helpers";
import { gatewayService } from "@/_services/gateway.service";

export function getCurrencyValuation(ctx) {
  return gatewayService.currencies.valuationInputs({
    currency: ctx.currencyNumber,
    format: "json",
    last: 1,
    observation_date: formatDate_YMDHMS(roundDateToFloor(ctx.initCurrencyDate))
  });
}
